<template>
  <div class="grid gap-4 my-4" :class="classes" v-if="block.data?.posts?.length">
    <div class="grid gap-0.5 max-w-prose" v-if="block.data?.title || block.data?.excerpt">
      <h2 class="font-bold md:text-lg" v-html="block.data?.title" />
      <p class="leading-6" v-if="block.data?.excerpt" v-html="block.data?.excerpt" />
    </div>
    <div class="grid gap-4" v-if="block.data?.posts?.length">
      <div v-for="post in block.data?.posts" :key="post.id" :class="{ 'one-up': count === 1, 'two-up': count === 2, 'three-up': count === 3 }">
        <NuxtLink :to="post.path" class="block">
          <BlocksRelatedCompactCard :post="post" />
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  block: Object
})

const classes = [
    props.block.data?.align === 'left' ? 'max-w-3xl' : null, 
    props.block.data?.align === 'center' ? 'w-full max-w-3xl mx-auto' : null,
  ].filter(str => str).join(' ')

const count = computed(() => props.block.data?.posts?.length)
</script>
